import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Spin, Switch, Tabs, Divider } from "antd";
import { getroutinglevelsCountry, getTimeZones } from "../../API/api";
import MultiSelectCM from "../MultiSelectCm/MultiSelectCm";
import { filterVisibleTopics } from "../../utils";
import { filtercmDomains } from "../../utils";
export default function EditRoleCM({ data, onChangeFunc, roleId }) {
  if (data.attributes[roleId].routingLevels === undefined) {
    data.attributes[roleId].routingLevels = {};
  }
  const userState = useSelector((state) => state.user);
  const [visibleTopics, setVisibleTopics] = useState(
    filterVisibleTopics(userState.expertTopics),
  );
  const [state, setState] = useState({
    region:
      data.attributes[roleId].routingLevels.atr2 === undefined
        ? []
        : {
            name: data.attributes[roleId].routingLevels.atr2,
            value: data.attributes[roleId].routingLevels.atr2,
            label: data.attributes[roleId].routingLevels.atr2,
          },
    currentCountry:
      data.attributes[roleId].routingLevels.atr1 === undefined
        ? []
        : {
            name: data.attributes[roleId].routingLevels.atr1,
            value: data.attributes[roleId].routingLevels.atr1,
            label: data.attributes[roleId].routingLevels.atr1,
          },
    countryList: [],
    domains:
      data.attributes[roleId].cmDomains === undefined
        ? []
        : filtercmDomains(data.attributes[roleId].cmDomains, visibleTopics),
  });
  const cmState = useSelector((state) => state.cmRoot);
  useEffect(() => {
    if (
      data.attributes[roleId].routingLevels.atr2 !== undefined &&
      state.countryList.length === 0
    ) {
      getroutinglevelsCountry(data.attributes[roleId].routingLevels.atr2).then(
        (res) => {
          if (res === undefined) return;
          setState({ ...state, countryList: res });
        },
      );
    }
  });

  // No auto-guessed default here, deliberately — same as Expert's blackout
  // period timezone. A guessed value (e.g. from the browser) would reflect
  // whoever is configuring this, not necessarily the CM's own location, and
  // could silently be wrong. Save is blocked in EditUserRole.js's onSubmit
  // until an Admin explicitly picks one.
  const [zoneList, setZoneList] = useState([]);
  useEffect(() => {
    getTimeZones().then((res) => {
      if (res === undefined) return;
      setZoneList(res);
    });
  }, []);

  const frequencyOptions = [
    { label: "Daily", value: "DAILY" },
    { label: "Weekly", value: "WEEKLY" },
    { label: "Bi-Weekly", value: "BIWEEKLY" },
    { label: "Monthly", value: "MONTHLY" },
  ];
  const defaultFrequencyOption = frequencyOptions.find(
    (f) => f.value === "WEEKLY",
  );

  const dayOptions = [
    { label: "Monday", value: "MONDAY" },
    { label: "Tuesday", value: "TUESDAY" },
    { label: "Wednesday", value: "WEDNESDAY" },
    { label: "Thursday", value: "THURSDAY" },
    { label: "Friday", value: "FRIDAY" },
    { label: "Saturday", value: "SATURDAY" },
    { label: "Sunday", value: "SUNDAY" },
  ];
  // Default day selection for Daily is Monday-Friday, not all 7 — matches
  // dayOptions' Mon-first ordering above.
  const weekdayOptions = dayOptions.slice(0, 5);

  // weekOfMonth is a single plain number 1-4 (not an array, not a "WEEK_1"
  // style string) per the confirmed backend contract.
  const weekOptions = [
    { label: "Week 1", value: 1 },
    { label: "Week 2", value: 2 },
    { label: "Week 3", value: 3 },
    { label: "Week 4", value: 4 },
  ];

  const emailAlert = data.attributes[roleId].expiredQuestionAlert || {
    frequency: "WEEKLY",
    daysOfWeek: null,
    weekOfMonth: null,
    timezone: null,
    enabled: false,
  };

  const frequencyOption =
    frequencyOptions.find((f) => f.value === emailAlert.frequency) ||
    defaultFrequencyOption;

  const hydratedDays = emailAlert.daysOfWeek
    ? dayOptions.filter((d) => emailAlert.daysOfWeek.includes(d.value))
    : frequencyOption.value === "DAILY"
      ? weekdayOptions
      : [dayOptions[0]];

  const hydratedWeek =
    emailAlert.weekOfMonth !== undefined && emailAlert.weekOfMonth !== null
      ? weekOptions.find((w) => w.value === emailAlert.weekOfMonth) ||
        weekOptions[0]
      : frequencyOption.value === "MONTHLY"
        ? weekOptions[0] // default Week 1
        : [];

  const [emailAlertState, setEmailAlertState] = useState({
    enabled: Boolean(emailAlert.enabled),
    frequency: frequencyOption,
    days: hydratedDays,
    week: hydratedWeek,
    timezone: emailAlert.timezone
      ? {
          name: emailAlert.timezone,
          value: emailAlert.timezone,
          label: emailAlert.timezone,
        }
      : [],
  });
  const onChangeRegion = (value) => {
    let origData = { ...data };
    if (state.region.value === value.value) {
      setState({ ...state, region: [], currentCountry: [], countryList: [] });
      delete origData.attributes[roleId].routingLevels.atr2;
      delete origData.attributes[roleId].routingLevels.atr1;
    } else {
      getroutinglevelsCountry(value.value).then((res) => {
        if (res === undefined) return;
        setState({
          ...state,
          region: value,
          currentCountry: [],
          countryList: res,
        });
        origData.attributes[roleId].routingLevels.atr2 = value.value;
        delete origData.attributes[roleId].routingLevels.atr1;
      });
    }
  };
  const onChangeCountry = (value) => {
    let origData = { ...data };
    if (state.currentCountry.value === value.value) {
      setState({ ...state, currentCountry: [] });
      delete origData.attributes[roleId].routingLevels.atr1;
    } else {
      setState({ ...state, currentCountry: value });
      origData.attributes[roleId].routingLevels.atr1 = value.value;
    }
  };

  const optionsWithSelectAllDomains = [
    { label: "Select All", value: "__all__" },
    ...visibleTopics,
  ];
  // const onChangeDomains = (value) => {
  //   let origData = {...data};
  //     setState({...state,domains:value });
  //     origData.attributes[roleId].cmDomains=value.map(dm=>dm.value);
  // };
  const onChangeDomains = (value = []) => {
    const isSelectAll = value.some((item) => item.value === "__all__");

    const selectedDomains = isSelectAll ? visibleTopics : value;

    setState({
      ...state,
      domains: selectedDomains,
    });

    let origData = { ...data };

    origData.attributes[roleId].cmDomains = selectedDomains.map(
      (dm) => dm.value,
    );
  };

  const optionsWithSelectAllDays = [
    { label: "Select All", value: "__all__" },
    ...dayOptions,
  ];

  // Guarantees weekOfMonth is always a valid 1-4 whenever the relevant
  // frequency is MONTHLY, even if the current `week` state happens to be
  // unset for some reason (e.g. re-enabling before ever touching the Week
  // dropdown). Falls back to Week 1 rather than omitting the key.
  const weekOfMonthPatch = (frequencyValue, weekState) =>
    frequencyValue === "MONTHLY" ? { weekOfMonth: weekState?.value || 1 } : {};

  const onChangeAlertEnabled = (val) => {
    setEmailAlertState({ ...emailAlertState, enabled: val });

    let origData = { ...data };
    origData.attributes[roleId].expiredQuestionAlert = {
      frequency: emailAlertState.frequency.value,
      daysOfWeek: emailAlertState.days.map((d) => d.value),
      ...weekOfMonthPatch(
        emailAlertState.frequency.value,
        emailAlertState.week,
      ),
      timezone: emailAlertState.timezone?.label || null,
      enabled: val,
    };
  };
  const onChangeFrequency = (value) => {
    let origData = { ...data };

    const isSingleSelectVariant =
      value.value === "WEEKLY" ||
      value.value === "BIWEEKLY" ||
      value.value === "MONTHLY";

    const defaultDays =
      value.value === "DAILY"
        ? weekdayOptions
        : isSingleSelectVariant
          ? [dayOptions[0]]
          : [];

    const defaultWeek = value.value === "MONTHLY" ? weekOptions[0] : [];

    const newState = {
      ...emailAlertState,
      frequency: value,
      days: defaultDays,
      week: defaultWeek,
    };
    setEmailAlertState(newState);

    origData.attributes[roleId].expiredQuestionAlert = {
      frequency: value.value,
      daysOfWeek: defaultDays.map((d) => d.value),
      ...weekOfMonthPatch(value.value, defaultWeek),
      timezone: emailAlertState.timezone?.label || null,
      enabled: emailAlertState.enabled,
    };
  };
  const onChangeAlertDays = (value) => {
    const isDaily = emailAlertState.frequency.value === "DAILY";

    if (isDaily) {
      const isSelectAll = (value || []).some(
        (item) => item.value === "__all__",
      );
      const selectedDays = isSelectAll ? dayOptions : value || [];

      setEmailAlertState({ ...emailAlertState, days: selectedDays });

      let origData = { ...data };
      origData.attributes[roleId].expiredQuestionAlert = {
        ...origData.attributes[roleId].expiredQuestionAlert,
        daysOfWeek: selectedDays.map((d) => d.value),
      };
      return;
    }

    // single-select variants (Weekly / Bi-Weekly / Monthly)
    const selectedDays = value ? [value] : [];
    setEmailAlertState({ ...emailAlertState, days: selectedDays });

    let origData = { ...data };
    origData.attributes[roleId].expiredQuestionAlert = {
      ...origData.attributes[roleId].expiredQuestionAlert,
      daysOfWeek: selectedDays.map((d) => d.value),
      ...weekOfMonthPatch(
        emailAlertState.frequency.value,
        emailAlertState.week,
      ),
    };
  };
  const onChangeAlertWeek = (value) => {
    setEmailAlertState({ ...emailAlertState, week: value });

    let origData = { ...data };
    origData.attributes[roleId].expiredQuestionAlert = {
      ...origData.attributes[roleId].expiredQuestionAlert,
      weekOfMonth: value?.value || 1,
    };
  };
  const onChangeAlertTimezone = (value) => {
    setEmailAlertState({ ...emailAlertState, timezone: value });

    let origData = { ...data };
    origData.attributes[roleId].expiredQuestionAlert = {
      ...origData.attributes[roleId].expiredQuestionAlert,
      timezone: value.label,
    };
  };

  return (
    <>
      <div className="mt-2">
        <span style={{ fontSize: "16px" }}>Set CM Location&nbsp;</span>
      </div>
      <div className="mt-3" style={{ display: "flex" }}>
        <div
          style={{
            width: "50%",
            display: "flex",
            alignItems: "baseline",
            flexWrap: "wrap",
          }}
        >
          <div
            style={{
              fontSize: "14px",
              whiteSpace: "nowrap",
              marginRight: "8px",
            }}
          >
            Region
          </div>
          <div style={{ marginTop: "7px" }}>
            <MultiSelectCM
              value={state.region}
              options={cmState.regionData}
              isMulti={false}
              onChangeFunc={onChangeRegion}
              isClearable={true}
            />
          </div>
        </div>
        <div
          style={{
            width: "50%",
            display: "flex",
            alignItems: "baseline",
            flexWrap: "wrap",
          }}
        >
          <div
            style={{
              fontSize: "14px",
              whiteSpace: "nowrap",
              marginRight: "8px",
            }}
          >
            Country
          </div>
          <div style={{ marginTop: "7px" }}>
            <MultiSelectCM
              onChangeFunc={onChangeCountry}
              options={state.region.length === 0 ? [] : state.countryList}
              value={state.currentCountry}
              isClearable={true}
            />
          </div>
        </div>
      </div>
      <div className="mt-3 " style={{ display: "flex", marginBottom: "10px" }}>
        <div
          style={{
            width: "50%",
            display: "flex",
            alignItems: "baseline",
            flexWrap: "wrap",
          }}
        >
          <div
            style={{
              fontSize: "14px",
              whiteSpace: "nowrap",
              marginRight: "8px",
            }}
          >
            Domains
          </div>
          <div style={{ marginTop: "7px" }}>
            <MultiSelectCM
              placeholder="Select Domains"
              onChangeFunc={onChangeDomains}
              options={optionsWithSelectAllDomains}
              value={state.domains}
              isMulti={true}
              isClearable={true}
            />
          </div>
        </div>
      </div>
      <Divider style={{ marginBlock: "10px" }} />

      <div className="mt-2" style={{ marginBottom: "20px" }}>
        <span style={{ fontSize: "16px" }}>
          Expired Questions Email Alert&nbsp;
        </span>
      </div>

      <div className="mt-3" style={{ display: "flex" }}>
        <div
          style={{
            width: "50%",
            display: "flex",
            alignItems: "center",
            flexWrap: "wrap",
          }}
        >
          <div
            style={{
              fontSize: "14px",
              whiteSpace: "nowrap",
              marginRight: "8px",
            }}
          >
            Enable
          </div>
          <div>
            <Switch
              value={emailAlertState.enabled}
              onChange={(e) => onChangeAlertEnabled(e)}
            />
          </div>
        </div>
      </div>
      {emailAlertState.enabled && (
        <>
          <div className="mt-3" style={{ display: "flex" }}>
            <div
              style={{
                width: "50%",
                display: "flex",
                alignItems: "baseline",
                flexWrap: "nowrap",
              }}
            >
              <div
                style={{
                  fontSize: "14px",
                  whiteSpace: "nowrap",
                  marginRight: "8px",
                }}
              >
                Frequency
              </div>
              <MultiSelectCM
                value={emailAlertState.frequency}
                options={frequencyOptions}
                isMulti={false}
                onChangeFunc={onChangeFrequency}
                isClearable={false}
              />
            </div>
            <div
              style={{
                width: "50%",
                display: "flex",
                alignItems: "baseline",
                flexWrap: "nowrap",
              }}
            >
              <div
                style={{
                  fontSize: "14px",
                  whiteSpace: "nowrap",
                  marginRight: "8px",
                }}
              >
                Timezone
              </div>
              <MultiSelectCM
                placeholder="Select Timezone"
                value={emailAlertState.timezone}
                options={zoneList}
                isMulti={false}
                onChangeFunc={onChangeAlertTimezone}
                isClearable={false}
              />
            </div>
          </div>
          {emailAlertState.frequency.value === "DAILY" && (
            <div className="mt-3" style={{ display: "flex" }}>
              <div
                style={{
                  width: "50%",
                  display: "flex",
                  alignItems: "baseline",
                  flexWrap: "nowrap",
                }}
              >
                <div
                  style={{
                    fontSize: "14px",
                    whiteSpace: "nowrap",
                    marginRight: "8px",
                  }}
                >
                  Days
                </div>
                <div style={{ marginTop: "7px" }}>
                  <MultiSelectCM
                    placeholder="Select Day"
                    value={emailAlertState.days}
                    options={optionsWithSelectAllDays}
                    isMulti={true}
                    onChangeFunc={onChangeAlertDays}
                    isClearable={false}
                  />
                </div>
              </div>
            </div>
          )}
          {(emailAlertState.frequency.value === "WEEKLY" ||
            emailAlertState.frequency.value === "BIWEEKLY" ||
            emailAlertState.frequency.value === "MONTHLY") && (
            <div className="mt-3" style={{ display: "flex" }}>
              <div
                style={{
                  width: "50%",
                  display: "flex",
                  alignItems: "baseline",
                  flexWrap: "wrap",
                }}
              >
                <div
                  style={{
                    fontSize: "14px",
                    whiteSpace: "nowrap",
                    marginRight: "8px",
                  }}
                >
                  Day
                </div>
                <div style={{ marginTop: "7px" }}>
                  <MultiSelectCM
                    placeholder="Select Day"
                    value={emailAlertState.days}
                    options={dayOptions}
                    isMulti={false}
                    onChangeFunc={onChangeAlertDays}
                    isClearable={false}
                  />
                </div>
              </div>

              {emailAlertState.frequency.value === "MONTHLY" && (
                <div
                  style={{
                    width: "50%",
                    display: "flex",
                    alignItems: "baseline",
                    flexWrap: "wrap",
                  }}
                >
                  <div
                    style={{
                      fontSize: "14px",
                      whiteSpace: "nowrap",
                      marginRight: "8px",
                    }}
                  >
                    Week
                  </div>
                  <div style={{ marginTop: "7px" }}>
                    <MultiSelectCM
                      value={emailAlertState.week}
                      options={weekOptions}
                      isMulti={false}
                      onChangeFunc={onChangeAlertWeek}
                      isClearable={false}
                    />
                  </div>
                </div>
              )}
            </div>
          )}
        </>
      )}
    </>
  );
}
